import { InjectionToken } from '@angular/core';

export const CIPAFACIL_APP_CONFIG = new InjectionToken<any>('CIPAFACIL_APP_CONFIG');
